<h1 id="page-title">Profile Page</h1>
<p id="page-description">
    <span>
        You can use the <strong>ID Token</strong> to get the profile information of an authenticated user.
    </span>
    <span>
        <strong>Only authenticated users can access this page.</strong>
    </span>
</p>

<ng-container *ngIf="user$ | async as user">
    <img [src]="user.picture" alt="Profile" />
    <h2>{{ user.name }}</h2>
    <span>{{ user.email }}</span>
    <ng-container *ngIf="code$ | async as code">
            <rendelo-code-snippet [title]="title" [code]="code">
            </rendelo-code-snippet>
    </ng-container>
</ng-container>